const quoteRequestStorageKey = 'ttfPendingQuoteRequest';

const showQuoteRequestError = (form, message) => {
  let error = form.querySelector('.quote-request__errors--client');
  if (!error) {
    error = document.createElement('p');
    error.className = 'quote-request__errors quote-request__errors--client';
    error.setAttribute('role', 'alert');
    form.prepend(error);
  }
  error.textContent = message;
};

const quoteRequestForm = document.getElementById('CartQuoteForm');

if (quoteRequestForm) {
  quoteRequestForm.addEventListener('submit', (event) => {
    try {
      const notes = document.getElementById('CartQuoteNotes');
      sessionStorage.setItem(quoteRequestStorageKey, JSON.stringify({
        note: notes ? notes.value : '',
        items: window.quoteRequestConfig?.items || null
      }));
    } catch (_) {
      event.preventDefault();
      showQuoteRequestError(
        quoteRequestForm,
        window.quoteRequestConfig?.submissionError || 'The quote request could not be prepared. Please try again.'
      );
    }
  });
}

const quoteRequestSuccess = document.querySelector('[data-quote-request-success]');

if (quoteRequestSuccess) {
  const finishQuoteRequest = async () => {
    let pending;

    try {
      pending = JSON.parse(sessionStorage.getItem(quoteRequestStorageKey));
    } catch (_) {
      return;
    }

    if (!pending) return;

    let step = 'history';

    try {
      if (pending.items && !pending.quoteId) {
        const quoteResponse = await fetch('/apps/quotes', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: pending.note, items: pending.items }),
          credentials: 'same-origin'
        });
        if (!quoteResponse.ok) throw new Error('history');

        const quote = await quoteResponse.json();
        pending.quoteId = quote.id;
        sessionStorage.setItem(quoteRequestStorageKey, JSON.stringify(pending));
      }

      step = 'clear';
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin'
      });
      if (!clearResponse.ok) throw new Error('clear');

      sessionStorage.removeItem(quoteRequestStorageKey);
      if (pending.items) window.location.assign('/pages/quote-history');
    } catch (error) {
      const message = step === 'clear'
        ? window.quoteRequestConfig?.clearError
        : window.quoteRequestConfig?.historyError;
      const status = document.createElement('p');
      status.className = 'form-status form-status-list form__message';
      status.setAttribute('role', 'alert');
      status.textContent = message || 'Your request was emailed, but the remaining quote steps could not be completed.';
      quoteRequestSuccess.insertAdjacentElement('afterend', status);
    }
  };

  void finishQuoteRequest();
}
